// extracted by css-extract-rspack-plugin
export default {"lastUpdated":"lastUpdated_g62E"};